export const uiConfig = {
  appLogo: '/dinolend-logo-header.svg',
};
